import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { CarreraModel } from 'app/modules/models/carreras.model';
import { RequerimientoCardComponent } from 'app/modules/global-components/card-requerimientos-academicos/requerimiento-card.component';
import { ExperienciaInterface } from 'app/modules/global-components/card-requerimientos-academicos/requerimientos.model';
import { REQUERIMIENTOS } from 'app/modules/global-components/card-requerimientos-academicos/requerimientos.model';
import { CommonModule } from '@angular/common';


@Component({
    selector: 'app-requerimietos-academicos',
    templateUrl: 'requerimientos-academicos.component.html',
    standalone: true,
    imports:[
        RequerimientoCardComponent, CommonModule
    ]
})

export class RequerimientosAcademicosComponent implements OnInit, OnChanges {
    @Input() carreaModel = new CarreraModel();
    requerimientos : ExperienciaInterface[] = REQUERIMIENTOS
    palabrasClave: string[] = [];

    constructor() { }

    ngOnInit() {
        this.palabrasClave = this.parsePalabrasClave(this.carreaModel?.palabraClave || '');
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['carreaModel']) {
            this.palabrasClave = this.parsePalabrasClave(this.carreaModel?.palabraClave || '');
        }
    }

    /**
     * Convierte el string de palabras clave en un array de strings
     */
    private parsePalabrasClave(raw: string): string[] {
        const limpio = (raw || '').trim();
        if (!limpio) {
            return [];
        }

        return limpio
            .split('-')
            .map(p => p.trim())
            .filter(Boolean)
            .map(p => {
                const m = p.match(/^\((\d+),(.*)\)$/);
                return m ? m[2] : p;
            });
    }
}
